import moment from 'moment';
import React, { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { numDifferentiation, TOAST_DURATION, TOAST_ERROR_COLOR, TOAST_POSITION } from '../../../../../common/app_constant';
import { ENV, s3_bucket_prod_url, s3_bucket_uat_url, SUB_DIRECTORY } from '../../../../../common/constant';
// import Blog from '../../../../../component/blog';
import Newsletter from '../../../../../component/newsletter';
import OurApp from '../../../../../component/our_app';
import RecommendedPolicy from '../../../../../component/recommended_policy';
import { actionDownload, actionNonHealthClaim, resetDownloadPolicyResponse, resetNonHealthClaimResponse } from '../../dashboard/store';
import _ from 'lodash';
import { useRef } from "react";
import Loader from '../../../../../component/page_loader';

const NonHealthClaims = () => {

    const dispatch = useDispatch()
    const navigation = useNavigate()


    const { nonHelthClaim, downloadPolicy } = useSelector((state) => ({
        ...state.dashboardStore
    }))


    const [filterArr, setFilterArr] = useState([])
    const [searchPolicy, setSearchPolicy] = useState('')

    const [clickednonhealth, setClickedNonHealthClaim] = useState("0");
    const contentElNonHealthClaim = useRef();

    const [nonHealthClaim, setNonHealthClaim] = useState([])
    const [isLoader, setIsLoader] = useState(true)


    useEffect(() => {

        dispatch(actionNonHealthClaim())

    }, [])



    useEffect(() => {
        if (downloadPolicy !== null) {
            dispatch(resetDownloadPolicyResponse())
            if (downloadPolicy.result === true) {
                if (downloadPolicy.status === true && Array.isArray(downloadPolicy.data.urls)) {
                    downloadPolicy.data.urls.forEach(item => {
                      if (item.url) {
                        window.open(item.url, '_blank');
                      }
                    });
                  }
            } else {
                switch (downloadPolicy.status_code) {
                    case 400:
                        toast.error(downloadPolicy.message, {
                            duration: TOAST_DURATION,
                            position: TOAST_POSITION,
                            style: {
                                color: TOAST_ERROR_COLOR
                            }
                        })
                        localStorage.clear()
                        navigation("/login");
                        break;
                    default:
                }
            }
        }
    }, [downloadPolicy])

    useEffect(() => {
        if (nonHelthClaim !== null) {
            dispatch(resetNonHealthClaimResponse())
            if (nonHelthClaim.result === true) {
                setIsLoader(false)
                setNonHealthClaim(nonHelthClaim.response)
                setFilterArr(nonHelthClaim.response)
            } else {
                setIsLoader(false)
                switch (nonHelthClaim.status_code) {
                    case 400:
                        toast.error(nonHelthClaim.message, {
                            duration: TOAST_DURATION,
                            position: TOAST_POSITION,
                            style: {
                                color: TOAST_ERROR_COLOR
                            }
                        })
                        localStorage.clear()
                        navigation("/login");
                        break;
                    default:
                }
            }
        }
    }, [nonHelthClaim])

    const handleToggleNonHealrhClaim = (index) => {
        if (clickednonhealth === index) {
            return setClickedNonHealthClaim("0");
        }
        setClickedNonHealthClaim(index);
    };


    const renderDocuments = (item) => {
        var arrDoc = []

        item != null && item.length > 0 ?
            item.map((item, index) => {
                arrDoc.push(
                    <div className="col-md-6">
                        <div className="card">
                            <div className="card-body d-flex justify-content-between">
                                <div className="col-10">
                                    <p className="mb-0">{item.actual_file_relative_url}</p>
                                    <small>{moment(item.created_at).format('YYYY-MM-DD HH:mm:ss')}</small>
                                </div>
                                <div className="col-2 text-center">
                                    <i className="fa fa-download cursor-pointer"
                                        onClick={(e) => {
                                            e.preventDefault()
                                            dispatch(actionDownload({ dmsIds: [item.id] }))
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                )
            })
            :
            arrDoc.push(
                <div class="col-md-12">
                    <div class="card">
                        <div class="card-body">
                            No Documents Uploaded
                        </div>
                    </div>
                </div>
            )

        return arrDoc

    }

    const renderNonHealthClaim = () => {
        var nonHealthClaimArr = []
        nonHealthClaim != null && nonHealthClaim.length > 0 ?
            nonHealthClaim.map((item, index) => {
                nonHealthClaimArr.push(
                    <div className="col-md-12 mb-4 mt-3">
                        <div className="card">
                            <div className="card-body">
                                <div className="accordion">
                                    <div className="row" onClick={() => {
                                        handleToggleNonHealrhClaim(index)
                                    }} style={{ cursor: 'pointer' }}>
                                        <div className="col-1 text-center my-auto">
                                            <img
                                                src={`${SUB_DIRECTORY}/assets/images/claim.png`}
                                                className="w-50"
                                                alt=""
                                            />
                                        </div>
                                        <div className="col-11 col-md-5">
                                            <p className="mb-0 fw-600">{_.capitalize(item.client_name)}</p>
                                            <small>Policy NO. : {item.policy_no}</small>
                                        </div>
                                        <div className="col-6 col-md-4 mt-2 mt-md-0">
                                            <p className="mb-0">Claim Amount</p>
                                            <p className="mb-0 fw-bold">₹ {numDifferentiation(item.amount)}</p>
                                        </div>
                                        <div className="col-6 col-md-2 text-center mt-2 mt-md-0">
                                            <span className="badge bg-primary rounded-pill">{_.capitalize(item.status)}</span>
                                        </div>
                                    </div>

                                    <div className="row border-top pt-2 mt-1" ref={contentElNonHealthClaim}
                                        hidden={clickednonhealth === index ? false : true}>
                                        <div className="col-12 col-md-4 mt-2">
                                            <label className="card-label">Policy Type :</label>
                                            <p className="card-value mb-0">
                                                {" "}{item.Policytype}
                                            </p>
                                        </div>
                                        <div className="col-6 col-md-4 mt-2">
                                            <label className="card-label">Intimation Date :</label>
                                            <p className="card-value mb-0">{moment(item.intimate_date).format('DD/MM/YYYY')}</p>
                                        </div>
                                        <div className="col-6 col-md-4 mt-2">
                                            <label className="card-label text-primary">
                                                Pinc Ref. No :{" "}
                                            </label>
                                            <p className="card-value mb-0">{item.pinc_claim_ref_no}</p>
                                        </div>
                                        <div className="col-6 col-md-4 mt-2">
                                            <label className="card-label">Date of Loss</label>
                                            <p className="card-value mb-0">{moment(item.date_of_loss).format('DD/MM/YYYY')}</p>
                                        </div>
                                        <div className="col-6 col-md-4 mt-2">
                                            <label className="card-label">Insurer</label>
                                            <p className="card-value mb-0">{item.insurer}</p>
                                        </div>
                                        <div className="col-6 col-md-4 mt-2">
                                            <label className="card-label">Nature of Claim</label>
                                            <p className="card-value mb-0">{item.nature_of_claim}</p>
                                        </div>
                                        <div className="col-6 col-md-4 mt-2">
                                            <label className="card-label">RM Name</label>
                                            <p className="card-value mb-0">{item.rm_name}</p>
                                        </div>
                                        <div className="col-6 col-md-4 mt-2">
                                            <label className="card-label">Claim Executive</label>
                                            <p className="card-value mb-0">{item.claim_csc_name}</p>
                                        </div>
                                        <div className="col-6 col-md-4 mt-2">
                                            <label className="card-label">Department</label>
                                            <p className="card-value mb-0">{item.department}</p>
                                        </div>
                                        <div className="col-6 col-md-4 mt-2">
                                            <label className="card-label">Claim Description</label>
                                            <p className="card-value mb-0">
                                                {item.loss_details}
                                            </p>
                                        </div>
                                        <div className="col-6 col-md-4 mt-2">
                                            <label className="card-label">Loss Location</label>
                                            <p className="card-value mb-0">{item.loss_location}</p>
                                        </div>
                                        <div className="col-6 col-md-4 mt-2">
                                            <label className="card-label">Claim Type</label>
                                            <p className="card-value mb-0">{item.claim_type}</p>
                                        </div>
                                        <div className="col-6 col-md-4 mt-2">
                                            <label className="card-label">Surveyor Name</label>
                                            <p className="card-value mb-0">{item.surveyor_name}</p>
                                        </div>
                                        <div className="col-12 mt-3">
                                            <h6>Documents({item.documents.length})</h6>
                                        </div>
                                        {renderDocuments(item.documents)}
                                    </div>
                                    <div className="row border-top pt-2 mt-1 fs-7">
                                        <div className="col-md-6 fw-bold border-end">
                                            Created On: <span>{moment(item?.created_at).format('DD/MM/YYYY')}</span>
                                        </div>
                                        <div className="col-md-6 fw-bold border-end">
                                            Modified On: <span>{moment(item?.updated_at).format('DD/MM/YYYY')}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )
            })
            :
            nonHealthClaimArr.push(
                <div className="d-flex justify-content-center align-items-center mt-5">
                    <h5>No Non Health Claims To Display</h5>
                </div>
            )
        return nonHealthClaimArr
    }

    return (
        <>

            <div className="row py-5">
                <div className="col-12">
                    <nav
                        className="--bs-breadcrumb-divider: '>';"
                        aria-label="breadcrumb"
                    >
                        <ol class="breadcrumb">
                            {/* <li class="breadcrumb-item"><a onClick={() => {
                                navigation('/dashboard')
                            }}>Dashboard</a></li> */}
                            <li class="breadcrumb-item active" aria-current="page">Non Health Claims</li>
                        </ol>
                    </nav>
                </div>
                <div className="col-12 col-md-8">
                    <div className="row">
                        <div className="col-12">
                            <div className="row px-2">
                                <div class="card profile-section col-md-12">
                                    <div class="card-body">
                                        <form>
                                            <div class="form-group has-search">
                                                <span class="fa fa-search form-control-feedback"></span>
                                                <input
                                                    type="text"
                                                    name="search"
                                                    class="form-control"
                                                    placeholder={'Search'}
                                                    value={searchPolicy}
                                                    onChange={(event) => {
                                                        setSearchPolicy(event.target.value)
                                                        var arrNonHealthClaims = Object.assign([], filterArr);
                                                        if (event.target.value.length > 0) {
                                                            setSearchPolicy(event.target.value)
                                                            var arrNonHealthClaims = arrNonHealthClaims.filter(
                                                                (item) =>
                                                                    item.insurer.toLowerCase().includes(event.target.value.toLowerCase()) ||
                                                                    item.client_name.toLowerCase().includes(event.target.value.toLowerCase()) ||
                                                                    item.policy_no.toLowerCase().includes(`${event.target.value.toLowerCase()}`)
                                                            );
                                                            setNonHealthClaim(arrNonHealthClaims)
                                                        } else {
                                                            setSearchPolicy(event.target.value)
                                                            setNonHealthClaim(arrNonHealthClaims)

                                                        }
                                                    }}
                                                />
                                            </div>
                                        </form>
                                    </div>
                                </div>
                                {/* <div class="col-md-3 my-auto">
                                                <button class="btn btn-primary btn-sm"
                                                    onClick={() => {
                                                        navigation('/intimate-claim', { state: { data: item } })
                                                    }}
                                                >
                                                    Intimate Claim</button>
                                            </div> */}
                            </div>
                        </div>
                    </div>
                    {
                        isLoader === true ?
                            <Loader />
                            :
                            <div className="row">
                                {renderNonHealthClaim()}
                            </div>
                    }

                </div>


                <div className="col-12 col-md-4">
                    <RecommendedPolicy />
                    {/* <Newsletter /> */}
                    {/* <Blog /> */}
                    {/* <OurApp /> */}
                    {/* <SocialMedia /> */}
                </div>
            </div>

        </>
    )

}

export default NonHealthClaims